import { render, staticRenderFns } from "./unfinished-loan.vue?vue&type=template&id=a8631390&scoped=true"
import script from "./unfinished-loan.vue?vue&type=script&lang=js"
export * from "./unfinished-loan.vue?vue&type=script&lang=js"
import style0 from "./unfinished-loan.vue?vue&type=style&index=0&id=a8631390&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8631390",
  null
  
)

export default component.exports